export default __webpack_public_path__ + "img/EF_NOMA.8e089a3850346de85b2e090a66dbc818.jpg";